import { render, staticRenderFns } from "./firmInfo.vue?vue&type=template&id=51cfca48&scoped=true"
import script from "./firmInfo.vue?vue&type=script&lang=js"
export * from "./firmInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cfca48",
  null
  
)

export default component.exports